
import { MdMsgBox } from 'mdesign-plus';

export const useWarnningMsgBox = (message, callback) => {
    MdMsgBox({
        message,
        type: 'warning',
        iconClass: 'md-icon-warning-outline',
        title: '',
        // customClass: 'md-messagebox confirm',
        confirmButtonText: 'OK',
        showClose: true,
        center: true,
        closeOnClickModal: false,
        lockScroll: false,
        callback
    });
}